import { render, staticRenderFns } from "./EditBank.vue?vue&type=template&id=138f868e&"
import script from "./EditBank.vue?vue&type=script&lang=ts&"
export * from "./EditBank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports